import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const getPpeKitQuery = (data) => {
  return axios.get(`${apiurl?.getPpeKit}?RankId=${data?.rankId}&RankCategoryName=${data?.rankCategory}&Gender=${data?.gender}&VesselId=${data?.plannedVesselId}`);
};

const getPpeKit = () => {
  return useMutation(getPpeKitQuery, {
    onSuccess: (res) => {
      return res?.data;
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};
export default getPpeKit;
